class RgcProductDiscovery extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    const options = { signal: this.abort.signal };
    this.addEventListener('click', event => {
      const arrow = event.target.closest('[data-rail]');
      if (arrow) {
        const rail = document.getElementById(arrow.dataset.rail);
        rail?.scrollBy({ left: Number(arrow.dataset.direction) * rail.clientWidth * .8, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      const color = event.target.closest('a[data-color]');
      if (!color || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const input = [...document.querySelectorAll('#gen-product-information .variant-picker input[type="radio"]')].find(input => input.value === color.dataset.color);
      if (!input) return; // Real variant URL remains a functional fallback.
      event.preventDefault();
      input.click();
      this.markColor(color.dataset.color);
      document.getElementById('gen-product-information')?.scrollIntoView({ behavior: 'instant', block: 'start' });
    }, options);
    document.addEventListener('change', event => {
      if (event.target.matches('#gen-product-information .variant-picker input[type="radio"]')) this.markColor(event.target.value);
    }, options);
  }
  markColor(color) {
    if (![...this.querySelectorAll('[data-color]')].some(link => link.dataset.color === color)) return;
    this.querySelectorAll('[data-color]').forEach(link => {
      if (link.dataset.color === color) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });
  }
  disconnectedCallback() { this.abort?.abort(); }
}
if (!customElements.get('rgc-product-discovery')) customElements.define('rgc-product-discovery', RgcProductDiscovery);
